//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Somos1V2UserRegionAccessComponent from '../Somos1V2RegionalIndicators1Page/Somos1V2UserRegionAccessComponent.vue';
export default {
  name: 'Somos1V2ConfigurationPage',
  components: {
    Somos1V2UserRegionAccessComponent: Somos1V2UserRegionAccessComponent
  }
};